module.exports = __webpack_public_path__ + "static/img/52-1.48bdb60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/52-1.jpg
// module id = uD1V
// module chunks = 0